import React, { useState } from "react";
import { Button } from "Components/Base/Inputs/Button";
import { Grid } from "Components/Base/Layout/Grid";
import { Box } from "Components/Base/Layout/Box";
import SearchField from "Components/Fragment/SearchField";
import FormControlSelect from "Components/Fragment/Inputs/FormControlSelect";
import { FilterIcon, FilterResetIcon } from "Components/Icons";

import { SORT_OPTIONS } from "../constants";
import { useLearningCatalogue } from "../context";
import {
  STYLE_SEARCH_FIELD_MOBILE_INNER,
  STYLE_CONTROLS_BOX_MOBILE_INNER,
} from "../styles";

const FilterControls = ({ languageContext, onFilter, isFilterOpen }) => {
  const handleFilterClick = () => {
    onFilter();
  };

  const filterContentLabel = isFilterOpen
    ? languageContext("hideCatalogueFilters")
    : languageContext("showCatalogueFilters");

  return (
    <Button
      variant="outlined"
      onClick={handleFilterClick}
      sx={{ color: "var(--colorTextPrimary)", borderColor: "transparent" }}
    >
      {isFilterOpen ? <FilterResetIcon /> : <FilterIcon />}
      {filterContentLabel}
    </Button>
  );
};

const ToolbarMobile = ({ languageContext }) => {
  const { state, setSearchText, handleShowAdvancedFilter, setSortOrder } =
    useLearningCatalogue();

  const { searchText, sortOrder } = state;

  const sortTypeOnChange = (updatedSortType) => {
    setSortOrder(updatedSortType);
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleSearchClear = async () => {
    await setSearchText("");
  };

  const handleSearchSubmit = async (searchValue) => {
    await setSearchText(searchValue);
  };

  const sortOptionValue =
    SORT_OPTIONS.find((option) => option.value === sortOrder)?.value || 0;

  return (
    <Grid
      container
      spacing={2}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid item xs={12}>
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          alignItems="stretch"
          justifyContent="space-between"
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            alignItems="stretch"
            sx={{ flex: "1" }}
          >
            <SearchField
              value={searchText}
              ariaLabel={languageContext("searchCatalogue")}
              placeholder={languageContext("searchCatalogue")}
              searchLabel={languageContext("searchCatalogue")}
              clearLabel={languageContext("clearSearch")}
              onChange={handleSearchChange}
              onClear={handleSearchClear}
              onSubmit={handleSearchSubmit}
              searchMode="onSubmit"
              sx={STYLE_SEARCH_FIELD_MOBILE_INNER}
            />
          </Box>

          <Box
            display="flex"
            alignItems="center"
            gap={1}
            flexWrap="wrap"
            sx={STYLE_CONTROLS_BOX_MOBILE_INNER}
          >
            {/* <FormControlSelect
              className="filter-sort-select"
              name={languageContext("sort")}
              options={SORT_OPTIONS}
              value={sortOptionValue}
              onChange={(sortValue) => sortTypeOnChange(sortValue)}
              languageContext={languageContext}
              displayLabel={false}
              sx={{
                height: "46px",
                minWidth: "100%",
                flexShrink: 0,
              }}
              translateOptions={true}
            />
            <FilterControls
              languageContext={languageContext}
              onFilter={handleShowAdvancedFilter}
              isFilterOpen={state.showAdvancedFilter}
            /> */}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ToolbarMobile;
